/*
 * @Author: lc
 * @Date: 2022-06-30 19:52:04
 * @Last Modified by: coocaa
 * @Last Modified time: 2023-06-Th 07:49:47
 * 用于生成表单校验，指定正则规则的触发方式。
 * 未在此处声明无触发方式的组件将不生成rule！！
 */

const ruleTrigger = {
  'el-input': ['blur', 'change'],
  'el-input-number': ['blur', 'change'],
  'el-select': 'change',
  'el-radio-group': 'change',
  'el-checkbox-group': 'change',
  'el-cascader': 'change',
  'el-time-picker': 'change',
  'el-date-picker': 'change',
  'el-rate': 'change',
  'el-switch': 'change',
  'el-upload': 'change'
}

export default ruleTrigger
